import React, { useEffect, useState } from "react";
import "chart.js/auto";
import "../Home/Home.css";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import InfiniteScroll from "react-infinite-scroll-component";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import Header from "../Header/Header";


const Statistics = () => {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState([]);
  const [expenses, setExpenses] = useState([]);
  const [expensesDetail, setExpensesDetail] = useState("");
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [expandedExpense, setExpandedExpense] = useState(null);
  const [graphData, setGraphData] = useState([]);
  const [category, setCategory] = useState([]);

  useEffect(() => {
    const token = localStorage.getItem("tokenexpense");
    if (!token) {
      navigate("/welcome");
    } else {
      fetchExpenses(token, 1, activeFilter);
    }
  }, [navigate,activeFilter]);

  const fetchCategory = async () => {
    try {
      const token = localStorage.getItem("tokenexpense");
      const response = await axios.get(
        `https://expense.dpstrust.in/api/category/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    console.log("Category fetched successfully", response.data.data.categoryData)
    setCategory(response.data.data.categoryData);
    setActiveFilter(response.data.data.categoryData[0].name)
    } catch (error) {
      console.error("Error fetching category:", error);
    } 
  };

  useEffect(()=>{
    fetchCategory();
  },[]);

  const fetchExpenses = async (token, currentPage, filter) => {
    try {
      const response = await axios.get(
        `https://expense.dpstrust.in/api/expense/all?page=${currentPage}&limit=10&category=${filter}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setExpensesDetail(response.data.data);
      setGraphData(response.data.data.graphData);

      if (response.data.status) {
        const newExpenses = response.data.data.expenses;

        // Filter out duplicates
        const uniqueExpenses = Array.from(
          new Map(
            [...expenses, ...newExpenses].map((item) => [item._id, item])
          ).values()
        );

        setExpenses(uniqueExpenses);
        if (newExpenses.length < 10) {
          setHasMore(false); // No more pages to load
        }
      }
    } catch (error) {
      console.error("Error fetching expenses:", error);
      setHasMore(false); // Stop loading on error
    }
  };

  // Sample data
  const home = Array.from({ length: 10 }, (_, index) => ({
    id: index + 1,
    image: "./Buying.png",
    title: "Shopping",
    date: "2024-11-17",
    description: "Groceries and essentials",
    price: `₹ ${1000 + index * 500}`,
  }));

  const handleFilterChange = (filter) => {
    if (filter === activeFilter) {
      return; 
    }
  
    setActiveFilter(filter);
    setExpenses([]);
    setPage(1); 
    setHasMore(true);
  };

  
  const userInitials = localStorage.getItem("userInitials");

  const toggleExpenseExpansion = (id) => {
    setExpandedExpense(expandedExpense === id ? null : id);
  };

  const loadMoreExpenses = () => {
    const token = localStorage.getItem("tokenexpense");
    const nextPage = page + 1;
    setPage(nextPage);
    fetchExpenses(token, nextPage, activeFilter);
  };


  return (
    <>
            <Header heading="Statistics" />

      <div className="home-container" style={{paddingTop:"70px"}}>
        {/* <div className="headinghome">Shopping</div>
        <div className="headingsubhome"> {expensesDetail?.totalExpense}</div> */}
      
        {/* Filter Buttons */}
        <div className="filter-buttons01">
          {category?.map((item) => (
            <button
              key={item?._id} style={{whiteSpace:"nowrap"}}
              className={`filter-button01 ${
                activeFilter === item?.name ? "active" : ""
              }`}
              onClick={() => handleFilterChange(item?.name)}
            >
              {item?.name}
            </button>
          ))}
        </div>

        {expenses.length === 0 && !hasMore && (
    <p style={{ textAlign: "center", color: "red" }}>No expenses available</p>
  )}
 
  <InfiniteScroll
    dataLength={expenses.length}
    next={loadMoreExpenses}
    hasMore={hasMore}
    loader={<h4>Loading more expenses...</h4>}
    endMessage={
      expenses.length > 0 ? (
        <p style={{ textAlign: "center" }}>No more expenses</p>
      ) : null
    }
  >
            <ul className="home-list">
          {expenses?.map((item) => {
    const getUserInitials = () => {
      const { firstName, lastName } = item?.user || {};
      const firstInitial = firstName?.charAt(0).toUpperCase() || "";
      const lastInitial = lastName?.charAt(0).toUpperCase() || "";
      return lastInitial ? `${firstInitial}${lastInitial}` : firstInitial;
    };

return (
            <li
              key={item?._id}
              className="home-item"
            >
              <div className="contlist" >{(item?.receiptFrontSideImage || item?.receiptBackSideImage || item?.description || item?.date) && (
  expandedExpense === item?._id ? (
    <IoIosArrowUp
      style={{ color: "#000", marginRight:"10px" }}
      onClick={() => toggleExpenseExpansion(item._id)}
    />
  ) : (
    <IoIosArrowDown
      style={{ color: "#000", marginRight:"10px" }}
      onClick={() => toggleExpenseExpansion(item._id)}
    />
  )
)} 
              <div className="home-image">{getUserInitials()}</div>
              <div className="home-details">
                <div className="home-title" style={{ textTransform: "capitalize", color:"#42224A" }}>{item?.category}</div>
                {item?.subCategory && (<div className="home-title1" style={{ textTransform: "capitalize" }}>({item?.subCategory})</div>)}
              </div>
              <div className="home-price">₹ {item?.amount}</div>
              </div>
           
             
              {expandedExpense === item._id && (
  <div className="expense-details">

    {item.description && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Description:</strong>
        <span style={{width:"200px", height:"auto", marginBottom:"10px"}}
        >{item?.description}
          </span>
      </div>
    )}
    {item.date && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Date:</strong>
        <span style={{width:"200px", height:"auto", marginBottom:"10px"}}
        >{new Date(item.date).toLocaleDateString()}
          </span>
      </div>
    )}
    {item.receiptFrontSideImage && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Receipt (Front):</strong>
        <img style={{width:"200px", height:"auto"}}
          // src="./card.png"
          src={item.receiptFrontSideImage}
          alt="Receipt Front"
          className="receipt-image"
        />
      </div>
    )}
    {item.receiptBackSideImage && (
      <div style={{display:"flex", width:"100%"}}>
        <strong style={{width:"140px"}}>Receipt (Back):</strong>
        <img style={{width:"200px", height:"auto"}}
                  // src="./card.png"
          src={item.receiptBackSideImage}
          alt="Receipt Back"
          className="receipt-image"
        />
      </div>
    )}
  </div>
)}

            </li>
);
})}
        </ul>
  </InfiniteScroll>

      </div>
    </>
  );
};

export default Statistics;
